const Climate = {
  CLEAR_DAY: {
    id: 1,
    name: "Dia ensolarado",
    icon: "fal fa-sun",
  },
  CLEAR_NIGHT: {
    id: 2,
    name: "Noite aberta",
    icon: "fal fa-moon-stars",
  },
  RAIN: {
    id: 4,
    name: "Chuvoso",
    icon: "fal fa-cloud-rain",
  },
  CLOUDY: {
    id: 8,
    name: "Nublado",
    icon: "fal fa-clouds",
  },
  PARTLY_CLOUDY_DAY: {
    id: 16,
    name: "Dia parcialmente nublado",
    icon: "fal fa-clouds-sun",
  },
  PARTLY_CLOUDY_NIGHT: {
    id: 32,
    name: "Noite parcialmente nublada",
    icon: "fal fa-clouds-moon",
  },
  FOG: {
    id: 64,
    name: "Neblina",
    icon: "fal fa-cloud-fog",
  },
  WIND: {
    id: 128,
    name: "Ventania",
    icon: "fal fa-wind",
  },
  UNDEFINED: {
    id: 0,
    name: "Indefinido",
    icon: "fal fa-cloud-question",
  },
};

const DayPeriod = {
  DAY: {
    id: 1,
    name: "Almoço",
    icon: "fal fa-clock",
  },
  NIGHT: {
    id: 2,
    name: "Jantar",
    icon: "fal fa-clock",
  },
  DAWN: {
    id: 4,
    name: "Madrugada",
    icon: "fal fa-clock",
  },
  UNDEFINED: {
    id: 0,
    name: "Indefinido",
    icon: "fal fa-clock",
  },
};

const WeekPeriod = {
  WORKINGDAYS: {
    id: 1,
    name: "Dia de semana",
    icon: "fal fa-calendar-day",
  },
  WEEKEND: {
    id: 2,
    name: "Final de semana",
    icon: "fal fa-calendar-week",
  },
  UNDEFINED: {
    id: 0,
    name: "Indefinido",
    icon: "",
  },
};

const YearPeriod = {
  AUTUMN: {
    id: 1,
    name: "Outono",
  },
  WINTER: {
    id: 2,
    name: "Inverno",
  },
  SPRING: {
    id: 4,
    name: "Primavera",
  },
  SUMMER: {
    id: 8,
    name: "Verão",
  },
  UNDEFINED: {
    id: 0,
    name: "Indefinido",
  },
};

const Temperature = {
  COLD: {
    id: 1,
    name: "Frio",
    description: "(10°-)",
    icon: "fal fa-temperature-frigid",
  },
  SOFT: {
    id: 2,
    description: "(10° - 20°)",
    icon: "fal fa-temperature-1",
    name: "Ameno",
  },
  HOT: {
    id: 4,
    name: "Calor",
    description: "(20° - 30°)",
    icon: "fal fa-temperature-2",
  },
  VERY_HOT: {
    id: 8,
    name: "Muito calor",
    description: "(30°+)",
    icon: "fal fa-temperature-high",
  },
  UNDEFINED: {
    id: 0,
    name: "Indefinido",
    icon: "fal fa-temperature-empty",
  },
};

class CustomerTag {
  constructor({ id, name, icon, quantity = 0, total = 0 }) {
    this.id = id;
    this.name = name;
    this.quantity = quantity;
    this.total = total;
    this.icon = icon;
  }

  static fromStats(tagEnum, tagStats, customerTotal) {
    const tags = Object.values(tagEnum).map((tag) => {
      const totalWithoutUndefined = customerTotal - (tagStats["0"] || 0);

      const tagTotal =
        parseInt(tag.id) == 0 ? customerTotal : totalWithoutUndefined;

      const tagQuantity = tagStats[tag.id] || 0;
      return {
        ...tag,
        quantity: tagQuantity,
        total: tagTotal,
      };
    });

    return tags.map((tag) => new CustomerTag({ ...tag }));
  }

  static fromEnum(tagEnum, tag) {
    const isUndefined = String(tag) == "0";
    if (!tag || isUndefined) {
      return [];
    }

    const tags = Object.values(tagEnum).filter(
      ({ id }) => (parseInt(tag) & id) >= id && id > 0
    );

    return tags.map((tag) => new CustomerTag({ ...tag }));
  }

  getPercentage() {
    return this.quantity / (this.total | 1);
  }

  getFormattedPercentage() {
    const percentage = this.getPercentage();
    return percentage.toLocaleString("pt-br", {
      style: "percent",
      maximumFractionDigits: 2,
    });
  }
}

export { CustomerTag, Climate, DayPeriod, WeekPeriod, YearPeriod, Temperature };
